import * as React from 'react';
import {useEffect, useState} from 'react';
import {logClkReport} from '@/utils/ubcUtils';
import {isWiseAgent} from '@/utils/utils';
import {VALUE_TYPE} from '@/dicts/consts';
import {NaviChildItem, TopicModule} from '../../../services/pages/channel/channel.client';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    show?: boolean;
    infos: TopicModule;
    moduleId?: string;
    channelBusinessLine?: string;
    childModuleId?: string;
    onItemClick?: (moduleId: string, childModuleId: string) => void;
    onStateChange?: (show: boolean) => void;
}

const SelfNaviSlideBar = (
    {show, infos, moduleId, childModuleId, onItemClick, onStateChange, page, channelBusinessLine}: Props
) => {

    const [targetModuleId, setTargetModuleId] = useState<string>();
    const [selectModuleId, setSelectModuleId] = useState<string>();
    const [selectChildModuleId, setChildModuleId] = useState<string>();
    const [slideBarStatus, setSlideBarStatus] = useState<boolean>(true);

    const renderNaviChild = (naviChilds: NaviChildItem[], moduleId: string) => {
        return (
            <div className={styles.subTitleContent}>
                {
                    naviChilds.map(
                        child => (
                            <div
                                key={child.moduleId}
                                className={
                                    child.moduleId === selectChildModuleId
                                        ? styles.selectSubTitle
                                        : styles.defaultSubTitle
                                }
                                onClick={() => {
                                    setSelectModuleId(moduleId);
                                    setTargetModuleId(moduleId);
                                    setChildModuleId(child.moduleId);
                                    onItemClick && onItemClick(moduleId, child.moduleId);
                                    logClkReport(
                                        page,
                                        'cebianlan_mulu',
                                        infos.channelId,
                                        channelBusinessLine,
                                        child.moduleId,
                                        child.title ?? '',
                                        {
                                            // eslint-disable-next-line camelcase
                                            value_type: VALUE_TYPE.ITEM,
                                        }
                                    );
                                }}
                            >
                                {child.title}
                            </div>
                        )
                    )
                }
            </div>
        );
    };

    useEffect(
        () => {
            setSelectModuleId(moduleId);
            if (targetModuleId === moduleId) {
                setTargetModuleId('');
            } else if (targetModuleId === '' && moduleId !== selectModuleId) {
                setChildModuleId('');
            }
        },
        [moduleId, childModuleId]
    );

    useEffect(
        () => {
            // @ts-ignore
            setSlideBarStatus(show);
            // eslint-disable-next-line max-len
            // slideBarStatus ? document.body.addEventListener('touchmove', (e) => {e.preventDefault()}, { passive: false })
            //     : document.body.style.display = 'none';
        },
        [show]
    );


    return (
        <div
            className={styles.parent}
            data-show={JSON.stringify({
                'page': page,
                'value': 'cebianlan_mulu',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >

            <div
                className={styles(slideBarStatus ? styles.leftArrowParentShow : styles.leftArrowParentHide, {
                    [styles.leftArrowParentHidePC]: !isWiseAgent(navigator.userAgent),
                })}
                onClick={() => {
                    // eslint-disable-next-line no-unused-expressions
                    slideBarStatus
                        ? onStateChange && onStateChange(false)
                        : onStateChange && onStateChange(true);
                    logClkReport(
                        page,
                        slideBarStatus ? 'cebianlan_hide' : 'cebianlan_open',
                        infos.channelId,
                        channelBusinessLine,
                        infos.moduleId,
                        infos.moduleName,
                        {
                            // eslint-disable-next-line camelcase
                            value_title: infos.moduleName ?? '',
                            // eslint-disable-next-line camelcase
                            value_type: VALUE_TYPE.MODULE,
                            // eslint-disable-next-line camelcase
                            value_id: infos.moduleId,
                        }
                    );
                }}
            >
                <img
                    onClick={() => {}}
                    src={'https://med-fe.cdn.bcebos.com/specialDisease/%20tuberculosis/navi-right.png'}
                    className={styles.leftArrowBg}
                />

                <img
                    onClick={() => {}}
                    src={
                        slideBarStatus
                            ? 'https://med-fe.cdn.bcebos.com/specialDisease/%20tuberculosis/arrow-close.png'
                            : 'https://med-fe.cdn.bcebos.com/specialDisease/%20tuberculosis/arrow-open2.gif'
                    }
                    className={styles.leftArrow}
                />

            </div>


            <div
                className={styles(slideBarStatus ? styles.slideContentShow : styles.slideContentHide, {
                    [styles.pc]: !isWiseAgent(navigator.userAgent),
                })}
            >

                {
                    infos.itemList?.length
                        ? infos.itemList[0].fieldValue?.showModuleList?.map(
                            naviItem => (
                                <div
                                    key={naviItem.moduleId}
                                    className={styles.content}
                                >
                                    <span
                                        className={
                                            naviItem.moduleId === selectModuleId
                                                ? styles.selectTitle
                                                : styles.defaultTitle
                                        }
                                        onClick={() => {
                                            setSelectModuleId(naviItem.moduleId);
                                            setTargetModuleId(moduleId);
                                            setChildModuleId('');
                                            onItemClick && onItemClick(naviItem.moduleId, '');
                                            logClkReport(
                                                page,
                                                'cebianlan_mulu',
                                                infos.channelId,
                                                channelBusinessLine,
                                                infos.moduleId,
                                                infos.moduleName,
                                                {
                                                    // eslint-disable-next-line camelcase
                                                    value_type: VALUE_TYPE.ITEM,
                                                    // eslint-disable-next-line camelcase
                                                    value_id: naviItem.moduleId,
                                                    // eslint-disable-next-line camelcase
                                                    value_title: naviItem.title,
                                                }
                                            );
                                        }}
                                    >
                                        {naviItem.title}
                                    </span>

                                    {
                                        naviItem?.children?.length
                                            ? <div className={styles.titleMargin} />
                                            : null
                                    }

                                    {
                                        naviItem?.children?.length
                                            ? renderNaviChild(naviItem.children, naviItem.moduleId)
                                            : null
                                    }

                                </div>
                            ))
                        : null
                }
            </div>

        </div>
    );
};

export default SelfNaviSlideBar;
